import { Select } from 'antd'
import styled from 'styled-components'
import React, { useEffect, useState } from 'react'
import { colors } from '../shared-constants/colors'
import { fontSize, fontsWeight } from '../shared-constants/fonts'
import { dimens } from '../shared-constants/dimens'

interface ICSelectProps {
  placeholder: string
  label?: string
  text?: string
  value?: any
  options?: any[]
  width?: string
  required?: boolean
  onChange?: any
  dataCyOption?: string
  className?: string
  dataCy?: string
  status?: string
  open?: boolean
  onClick?: () => {}
  onClear?: () => void
  error?: boolean
}
const Option = Select.Option
export const CSelect = (props: ICSelectProps) => {
  const [focus, setFocus] = useState<boolean>(false)
  const [value, setValue] = useState(props.value)
  const [open, setOpen] = useState<boolean>(props.open ?? false)
  const [error, setError] = useState<boolean>(props.error ?? false)
  const {
    required,
    label,
    text,
    placeholder = 'انتخاب کنید',
    width,
    dataCy,
    className,
    dataCyOption,
    onClear,
    onClick,
  } = props

  const onChange = (value: any) => {
    setValue(value)
  }

  const requiredText = required ? (
    <ErrorText>این مقدار الزامی است.</ErrorText>
  ) : (
    <Guide>{text}</Guide>
  )

  useEffect(() => {
    props.onChange?.(value)
  }, [value])

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  useEffect(() => {
    setOpen(props.open ?? false)
  }, [props.open])

  const checkOpen = () => {
    if (props?.open !== undefined) {
      return { open: props.open }
    } else {
      return {}
    }
  }

  const handleFocus = () => {
    setFocus(true)
    setOpen(true)
  }

  const handleBlur = () => {
    setFocus(false)
    setOpen(false)
  }

  return (
    <>
      <Subject>{label}</Subject>
      <CustomSelect
        {...checkOpen()}
        //   {...props}
        // showSearch
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        size='large'
        width={width}
        className={`${className} ${error ? 'error' : ''}`}
        data-cy={dataCy}
        onClear={onClear}
        onFocus={handleFocus}
        onBlur={handleBlur}
        getPopupContainer={(trigger) => trigger.parentNode}
        onClick={onClick}
      >
        {props?.options?.map((option) => {
          return (
            <Option className={dataCyOption} value={option.value}>
              {option.label}
            </Option>
          )
        })}
      </CustomSelect>
      {requiredText}
    </>
  )
}
interface CustomSelectType {
  width: string
}

const CustomSelect = styled(Select)<CustomSelectType>`
  width: ${(props) => (props.width ? props.width : '100%')};
  border: ${dimens.BORDER_WIDTH_THIN};
  //Normal
  .ant-select-selector {
    border-radius: ${dimens.BORDER_RADIUS_4} !important;
    height: ${dimens.HEIGHT_SMALL} !important;
    background-color: ${colors.bg2} !important;
    border-color: ${colors.stroke2} !important;
  }

  &:hover {
    .ant-select-selector {
      background-color: ${colors.bg2Hover} !important;
      border-color: ${colors.stroke3} !important;
    }
  }
  &:active {
    .ant-select-selector {
      background-color: ${colors.bg2Press} !important;
      border-color: ${colors.stroke4} !important;
    }
  }

  .ant-select-selection-placeholder {
    margin-top: ${dimens.SPACING_XXXS} !important;
  }
  .ant-select-clear {
    opacity: 1 !important;
  }

  //focuse
  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-color: ${colors.primaryBrandStroke} !important;
    box-shadow: none !important;
  }
  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-arrow {
    transform: rotate(180deg) !important;
  }
  //error
  &.error .ant-select-selector {
    border-color: ${colors.criticalStroke} !important;
    background-color: ${colors.criticalBg5} !important;
  }
  &.error .ant-select-selector:hover {
    border-color: ${colors.criticalStroke2} !important;
    background-color: ${colors.criticalBg5} !important;
  }

  &.error .ant-select-selector {
    border-color: ${colors.criticalStroke3} !important;
    background-color: ${colors.criticalBg5} !important;
  }

  .ant-select-item-option {
    background-color: ${colors.bg} !important;
  }
  .ant-select-item-option-active {
    background-color: ${colors.bgHover} !important;
  }
  .ant-select-item-option-selected {
    background-color: ${colors.bgPress} !important;
  }
  .ant-select-selection-placeholder {
    color: ${colors.text4} !important;
    font-size: ${fontSize.NORMAL} !important;
    font-weight: ${fontsWeight.NORMAL} !important;
  }
`

const Subject = styled.p`
  font-size: ${fontSize.SMALL};
  font-weight: ${fontsWeight.MEDIUM};
  margin-bottom: ${dimens.SPACING_XXS};
  color: ${colors.text3};
`
const Guide = styled.p`
  font-size: ${fontSize.SMALL};
  font-weight: ${fontsWeight.MEDIUM};
  color: ${colors.text3};
  margin-top: ${dimens.SPACING_XXS};
`
const ErrorText = styled.p`
  font-size: ${fontSize.SMALL};
  font-weight: ${fontsWeight.MEDIUM};
  color: ${colors.criticalText};
  margin-top: ${dimens.SPACING_XXS};
`
